import { SettingsBreadCrumbService, BreadCrumbOptions } from '../settings-breadcrumb.service';
import { IdsForSettingsService } from '../ids-for-settings.service';
import { PermissionsApiClient } from 'src/app/services/api-clients/permissions.apiclient';
import { PermissionGroup } from 'src/app/constants/settings.enum';
import { PermissionsService } from '../permissions.service';

export class SettingsBasePermissionsPage {
  permissions: any[] = [];
  permissionGroupValues :string[] =[];

  constructor(protected permissionsApiClient: PermissionsApiClient, 
              protected settingsBreadCrumbService: SettingsBreadCrumbService, 
              protected idsForSettingsService: IdsForSettingsService,
              protected permissionsService: PermissionsService
    ) {
      this.permissionGroupValues = Object.values(PermissionGroup).filter(enumValue => enumValue != PermissionGroup.Setting);

  }

  getPermissionGroup(permissionGroupValue: string): PermissionGroup {
    let permissionGroup: PermissionGroup = permissionGroupValue as PermissionGroup;
    return permissionGroup;
  }
}